import { render, staticRenderFns } from "./PlayerChatUnblockLink.vue?vue&type=template&id=762068d8&"
import script from "./PlayerChatUnblockLink.vue?vue&type=script&lang=js&"
export * from "./PlayerChatUnblockLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports